<template>
  <div
    v-if="event.materialResourcesCollection?.length"
    class="flex flex-row gap-4 group-hover/event-card:gap-6"
  >
    <AssignedMaterialResource
      v-for="materialResource in event.materialResourcesCollection"
      :key="materialResource.id"
      v-model:drag-over-resource="dragOverResource"
      :event="event"
      :assigned-material-resource="materialResource"
      :can-be-dropable="canBeDropable"
      :editable="editable"
      :size="size"
      @fetch-events="$emit('fetch-events')"
      @event-updated="(event) => (localEvent = event)"
    />
  </div>
</template>

<script>
import AssignedMaterialResource from '@c/Dashboard/Content/Planning/components/AssignedMaterialResource.vue'

export default {
  name: 'AssignedMaterialResourcesList',
  components: { AssignedMaterialResource },
  props: {
    event: {
      type: Object,
      required: true
    },
    canBeDropable: {
      type: Boolean,
      required: false,
      default: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    }
  },
  emits: ['update:event', 'fetch-events'],
  data() {
    return {
      dragOverResource: false
    }
  },
  computed: {
    localEvent: {
      get() {
        return this.event
      },
      set(value) {
        this.$emit('update:event', value)
      }
    }
  }
}
</script>
